import React, { useState, useEffect, useContext,useCallback } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import NormalOnboarding from "../addNormal/Normal";

const UpdateNormalOnboarding = ({
                         match,
                         documentUrlDataPublic,
                         documentUploadUrlPublic,
                         getLeadInfraId,
                         leadInfraId,
                         getNormalOnboarding,
                         normalOnboradingData,
                         updateNormalOnboardingData,
                     }) => {

    const [isLoading, setIsLoading] = useState(false);
    const inputs = {
        meetingDetails: null,
    };

    //For Updating Carnival
    const getCarnivalData = useCallback(async () => {
        if (match?.params?.id) {
            setIsLoading(true);
            await getNormalOnboarding(match?.params?.id);
            setIsLoading(false);
        }
    }, [getNormalOnboarding, match?.params?.id]);

    useEffect(() => {
        getCarnivalData();
    }, [getCarnivalData]);

    return (
        <>
            <NormalOnboarding
                getLeadInfraId={getLeadInfraId}
                leadInfraId={leadInfraId}
                documentUploadUrlPublic={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                prefilledData={normalOnboradingData}
                updateNormalOnboardingData={updateNormalOnboardingData}
            />
        </>
    );
};

UpdateNormalOnboarding.propTypes = {};

export default UpdateNormalOnboarding;
